import { cn } from "@/lib/utils";

interface ThemeColorPreviewProps {
  primary: string;
  accent: string;
  secondary: string;
}

export const ThemeColorPreview = ({ primary, accent, secondary }: ThemeColorPreviewProps) => {
  return (
    <div 
      className="h-12 w-full rounded-md"
      style={{ 
        background: `linear-gradient(135deg, ${primary} 0%, ${accent} 50%, ${secondary} 100%)`
      }} 
    />
  );
};